import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * @file  pagination
 * @author chenyaqiu
 */
import * as React from 'react';
import classNames from 'classnames';
import OutlinedLeft from "acud-icon/es/icons/OutlinedLeft";
import OutlinedRight from "acud-icon/es/icons/OutlinedRight";
import OutlinedLeftDouble from "acud-icon/es/icons/OutlinedLeftDouble";
import OutlinedRightDouble from "acud-icon/es/icons/OutlinedRightDouble";
import OutlinedEllipsisSquare from "acud-icon/es/icons/OutlinedEllipsisSquare";
import { ConfigContext } from '../config-provider';
import LOCALE from './locale/zh_CN';
import RcPagination from './rc-pagination';
import Select from '../select';
export var Option = Select.Option;
var Pagination = function Pagination(_a) {
  var customizePrefixCls = _a.prefixCls,
    customizeSelectPrefixCls = _a.selectPrefixCls,
    className = _a.className,
    size = _a.size,
    showQuickJumper = _a.showQuickJumper,
    showSizeChanger = _a.showSizeChanger,
    restProps = __rest(_a, ["prefixCls", "selectPrefixCls", "className", "size", "showQuickJumper", "showSizeChanger"]);
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    direction = _React$useContext.direction;
  var prefixCls = getPrefixCls('pagination', customizePrefixCls);
  var getIconsProps = function getIconsProps() {
    var ellipsis = /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-item-ellipsis")
    }, /*#__PURE__*/React.createElement(OutlinedEllipsisSquare, null));
    var prevIcon = /*#__PURE__*/React.createElement("button", {
      className: "".concat(prefixCls, "-item-link"),
      type: "button",
      tabIndex: -1
    }, /*#__PURE__*/React.createElement(OutlinedLeft, null));
    var nextIcon = /*#__PURE__*/React.createElement("button", {
      className: "".concat(prefixCls, "-item-link"),
      type: "button",
      tabIndex: -1
    }, /*#__PURE__*/React.createElement(OutlinedRight, null));
    var jumpPrevIcon = /*#__PURE__*/React.createElement("a", {
      className: "".concat(prefixCls, "-item-link")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-item-container")
    }, /*#__PURE__*/React.createElement(OutlinedLeftDouble, {
      className: "".concat(prefixCls, "-item-link-icon")
    }), ellipsis));
    var jumpNextIcon = /*#__PURE__*/React.createElement("a", {
      className: "".concat(prefixCls, "-item-link")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-item-container")
    }, /*#__PURE__*/React.createElement(OutlinedRightDouble, {
      className: "".concat(prefixCls, "-item-link-icon")
    }), ellipsis));
    return {
      prevIcon: prevIcon,
      nextIcon: nextIcon,
      jumpPrevIcon: jumpPrevIcon,
      jumpNextIcon: jumpNextIcon
    };
  };
  // const renderQuickJumper = () => <Button type='default'>GO</Button>;
  var renderPagination = function renderPagination() {
    var isSmall = size === 'small' || !!(!size && restProps.responsive);
    var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
    var extendedClassName = classNames(_defineProperty({
      mini: isSmall
    }, 'rtl', direction === 'rtl'), className);
    return /*#__PURE__*/React.createElement(RcPagination, _extends({
      showSizeChanger: showSizeChanger,
      locale: LOCALE
    }, restProps, {
      prefixCls: prefixCls,
      selectPrefixCls: selectPrefixCls
    }, getIconsProps(), {
      className: extendedClassName,
      selectComponentClass: showSizeChanger ? Select : undefined,
      Option: Option,
      showQuickJumper: showQuickJumper
    }));
  };
  return renderPagination();
};
export default Pagination;